<template>
  <div :id="id" :class="customClass"></div>
</template>

<script>
import * as d3 from "d3";
import $ from "jquery";
export default {
  props: ["id", "customClass"],
  data() {
    return {};
  },
  methods: {
    async playOut() {
      console.log('退出')
    },
    //核心库
    CustomTreeChart(
      data,
      {
        marginTop = 0, // the top margin, in pixels
        marginRight = 0, // the right margin, in pixels
        marginBottom = 0, // the bottom margin, in pixels
        marginLeft = 30, // the left margin, in pixels
        width = 960, // the outer width of the chart, in pixels
        height = 400, // the outer height of the chart, in pixels
        multiple = 1, // 默认1，从主节点的边缘出发
        duration = 1000, //动画持续时长
        delay = 500, //元素之间间隔时长
        ease = "easeBack",
        lineWidth = 100,
        nodeLength = 100, // 起点宽高
        branchNodeWidth = 100,  // 分支宽度
        branchNodeHeight = 50, // 分支高度
      } = {}
    ) {
        const innerWidth = width - marginLeft - marginRight
        const innerHeight = height - marginTop - marginBottom
        const svg = d3.create("svg")
            .attr("width", width)
            .attr("height", height)
        $("#" + this.id).html(svg.node());

        this.svg = svg.append("g").attr("transform", "translate("+ marginLeft + "," + marginTop + ")");
        this.treemap = d3.tree().size([innerHeight, innerWidth]);
        let root = d3.hierarchy(data, function(d) { return d.children; });
        root.x0 = innerHeight / 2;
        root.y0 = 0;
        this.root = root
        this.duration = duration
        this.delay = delay
        this.multiple = typeof multiple === 'number' &&  multiple > 0 ? multiple : 1
        this.ease = ease
        this.lineWidth = lineWidth
        this.nodeLength = nodeLength
        this.branchNodeWidth = branchNodeWidth
        this.branchNodeHeight = branchNodeHeight
        this.update(root);
    },
    update(source) {
        const _that = this
        // Assigns the x and y position for the nodes
        let treeData = this.treemap(this.root);
        // Compute the new tree layout.
        let nodes = treeData.descendants(),
            links = treeData.descendants().slice(1);
        // Normalize for fixed-depth.
        nodes.forEach(function(d){
            // 0.2 缩短线的距离
            d.y = d.depth * _that.lineWidth+ _that.nodeLength*0.2/ _that.multiple
        });

        // 添加根节点
        this.svg.selectAll('g.nodeMain')
            .data(nodes.slice(0, 1), function(d) {return d.id})
            .enter().append('g').attr('class', 'nodeMain')
            .attr("transform", function(d) {
               return "translate(" + d.y0 + "," + d.x0 + ")";
            })
            .attr('opacity', '0')
            .append('foreignObject')
            .attr('overflow', 'inherit')
            .attr('width', _that.nodeLength)
            .attr('height', _that.nodeLength)
            .attr('transform', `translate(0, -${ _that.nodeLength / 2 })`)
            .append('xhtml:div')
            .attr('class', 'main')
            .style('width', '100%')
            .style('height', '100%')
            .style('display', 'flex')
            .style('align-items', 'center')
            .style('justify-content', 'center')
            .append('span')
            .attr("class", "main_content")
            .html((i) => i.data.name)
        // 根节点动画
        d3.select('.nodeMain').transition()
            .ease(d3[_that.ease + "Out"])
            .duration(_that.duration)
            .attr('opacity', '1');
       
        // 添加&&更新分支节点
        let node = this.svg.selectAll('g.node')
            .data(nodes.slice(1), function(d) { return d.id });
        // Enter any new modes at the parent's previous position.
        let nodeEnter = node.enter().append('g')
            .attr('class', (i) => {
                return 'node'+i.depth
                })
            .attr("transform", function(d) {
                    return "translate(" + source.y0 + "," + source.x0 + ")";
 
            })
            .attr('opacity', '0')
            nodeEnter.append('foreignObject')
            .attr('width', _that.branchNodeWidth)
            .attr('height', _that.branchNodeHeight)
            .attr('transform', `translate(0, -${_that.branchNodeHeight / 2})`)
            .append('xhtml:div')
            .attr('class', (i) => {
                return 'branch'+i.depth
                })
            .style('width', '100%')
            .style('height', '100%')
            .style('display', 'flex')
            .style('align-items', 'center')
            .style("justify-content", "center")
            .append('span')
            .attr('class', 'node-branch')
            .html((i) => i.data.name)
        // UPDATE
        let nodeUpdate = nodeEnter.merge(node);
        // Transition to the proper position for the node
        nodeUpdate.transition()
            .duration(_that.duration)
            .ease(d3[_that.ease + "Out"])
            .delay(_that.delay)
            .attr("transform", function(d) { 
                if(d.depth==1){
                    return `translate(${d.y*0.6}, ${d.x})`;
                }else if(d.depth==2) {
                    return `translate(${d.y*0.8}, ${d.x})`;
                }else{
                    return `translate(${d.y*0.9}, ${d.x})`;
                }
                
            })
            .attr('opacity', '1');
        // ****************** links section ***************************
        // 添加树线
        let link = this.svg.selectAll('path.link')
            .data(links, function(d) { return d.id; });

        // Enter any new links at the parent's previous position.
        let linkEnter = link.enter().insert('path', "g")
            .attr("class", (i) => {
                return "link"+i.depth
                })
            .attr('d', function(d){
                let o = {x: source.x0, y: source.y0}
                return _that.diagonal(o, o)
            })
            .attr('fill', 'none')
            .attr('stroke-width', 2)
            .attr('stroke', '#FFC100')
            // .attr('stroke-dasharray', '5,5')
        // UPDATE
        let linkUpdate = linkEnter.merge(link);

        // Transition back to the parent element position
        linkUpdate.transition()
            .duration(_that.duration)
            .ease(d3[_that.ease + "Out"])
            .delay(_that.delay)
            .attr('d', function(d){ return _that.diagonal(d, d.parent) });
            
    },
    diagonal(s, d) {
        // let path = `M ${s.y} ${s.x}
        //         C ${(s.y + d.y) / 2} ${s.x},
        //         ${(s.y + d.y) / 2} ${d.x},
        //         ${d.y} ${d.x}`
        let path
        if(d.depth==1){
            path = `M ${d.y} ${d.x}, ${(s.y + d.y) / 2} ${d.x}, ${(s.y + d.y) / 2} ${s.x}, ${s.y} ${s.x}`
        }else if(d.depth==2){
            path = `M ${d.y} ${d.x}, ${(s.y + d.y) / 2} ${d.x}, ${(s.y + d.y) / 2} ${s.x}, ${s.y} ${s.x}`
        }else{
            path = `M ${d.y} ${d.x}, ${(s.y + d.y) / 2} ${d.x}, ${(s.y + d.y) / 2} ${s.x}, ${s.y} ${s.x}`
        }

        // console.log(path);
        return path
    },
  },
};
</script>

